<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="700px" scrollable>
    <v-card v-if="solicitacao">
      <v-card-title class="d-flex justify-space-between">
        <span class="text-h6">Histórico da Justificativa</span>
        <v-btn icon aria-label="Fechar" @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-timeline dense>
          <v-timeline-item
            v-for="(item, i) in etapas"
            :key="i"
            :color="item.cor"
            :icon="item.icone"
            fill-dot
            small
          >
            <v-row>
              <v-col cols="12" sm="5">
                <div class="font-weight-bold">{{ item.titulo }}</div>
                <div class="text-caption text--secondary" v-if="item.data">
                  {{ formatarDataHora(item.data) }}
                </div>
              </v-col>
              <v-col cols="12" sm="7">
                <v-chip x-small label :color="item.cor" text-color="white" class="mb-1">
                  {{ item.chip }}
                </v-chip>
                <div v-if="item.pessoa" class="font-weight-medium">
                  {{ item.rotuloPessoa }} {{ item.pessoa }}
                </div>
                <div v-if="item.periodo" class="mt-1">
                  <span class="font-weight-medium">Período justificado:</span>
                  {{ item.periodo }}
                </div>
                <div v-if="item.mensagem" class="mt-1">{{ item.mensagem }}</div>
                <div v-if="item.observacao" class="mt-1">
                  <span class="font-weight-medium">Observação:</span> {{ item.observacao }}
                </div>
              </v-col>
            </v-row>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input', false)">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const EVENTO_INFO = {
  CRIADO: {
    titulo: "Criado em",
    chip: "Aguardando",
    cor: "grey",
    icone: "mdi-plus-circle-outline",
  },
  CONFIRMADO: {
    titulo: "Confirmado",
    chip: "Justificativa confirmada",
    cor: "green",
    icone: "mdi-check-circle-outline",
  },
  REJEITADO: {
    titulo: "Rejeitado",
    chip: "Justificativa rejeitada",
    cor: "red",
    icone: "mdi-close-circle-outline",
  },
  REVOGADO: {
    titulo: "Revogado",
    chip: "Justificativa revogada",
    cor: "orange",
    icone: "mdi-undo-variant",
  },
};

export default {
  props: {
    value: { type: Boolean, default: false },
    solicitacao: { type: Object, default: null },
  },
  computed: {
    etapas() {
      if (!this.solicitacao) return [];
      const historico = this.solicitacao.historico || [];
      const etapas = [];

      const criado = historico.find((h) => h.tipo_evento === "CRIADO");
      etapas.push({
        ...EVENTO_INFO.CRIADO,
        data: criado ? criado.created_at : this.solicitacao.created_at,
        rotuloPessoa: "Criado por",
        pessoa: this.nomePessoa(criado ? criado.realizado_por : this.solicitacao.criador),
        mensagem: "Justificativa criada pelo responsável.",
      });

      const eventosDeAnalise = historico.filter((h) => h.tipo_evento !== "CRIADO");

      if (eventosDeAnalise.length === 0) {
        etapas.push({
          titulo: "Aguardando análise",
          chip: "Aguardando resposta",
          cor: "grey",
          icone: "mdi-clock-outline",
          mensagem: "A justificativa ainda não foi analisada pelo gestor responsável.",
        });
        return etapas;
      }

      eventosDeAnalise.forEach((evento) => {
        const info = EVENTO_INFO[evento.tipo_evento] || EVENTO_INFO.REJEITADO;
        etapas.push({
          ...info,
          data: evento.created_at,
          rotuloPessoa: evento.tipo_evento === "REVOGADO" ? "Revogado por" : "Analisado por",
          pessoa: this.nomePessoa(evento.realizado_por),
          periodo:
            evento.tipo_evento === "CONFIRMADO" && evento.data_inicial && evento.data_final
              ? `${this.formatarData(evento.data_inicial)} a ${this.formatarData(
                  evento.data_final
                )}`
              : null,
          observacao: evento.observacao || null,
        });
      });

      const ultimoEvento = eventosDeAnalise[eventosDeAnalise.length - 1];
      if (ultimoEvento.tipo_evento === "REVOGADO" && this.solicitacao.status === "REJEITADO") {
        etapas.push({
          ...EVENTO_INFO.REJEITADO,
          data: this.solicitacao.data_analise,
          rotuloPessoa: "Analisado por",
          pessoa: this.nomePessoa(this.solicitacao.analisado_por),
          observacao: this.solicitacao.motivo_rejeicao,
        });
      }

      return etapas;
    },
  },
  methods: {
    nomePessoa(pessoa) {
      if (!pessoa) return "";
      const role = pessoa.roles && pessoa.roles.length ? ` (${pessoa.roles[0].name})` : "";
      return `${pessoa.name}${role}`;
    },
    formatarData(data) {
      if (!data) return "---";
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}/${ano}`;
    },
    formatarDataHora(data) {
      if (!data) return "";
      return new Date(data)
        .toLocaleString("pt-BR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })
        .replace(",", " às");
    },
  },
};
</script>
